// 判断当前页面是否需要链接转换
function isTargetPage() {
    const path = window.location.pathname;
    
    // 检查是否为目标页面类型
    const targetPatterns = [
        /\/products\//,
        /\/blogs\//,
        /\/journal\//,
        /\/collections\//,
        /\/pages\//
    ];
    
    // 检查是否匹配任何目标模式
    for (const pattern of targetPatterns) {
        if (pattern.test(path)) {
            return true;
        }
    }
    
    // 检查是否是博客主页
    if (path === '/blogs' || path === '/journal') {
        return true;
    }
    
    return false;
}

// 获取当前语言代码
function getCurrentLocale() {
    const path = window.location.pathname;
    
    // 检查路径是否包含语言代码（如 /de/products/...）
    const localeMatch = path.match(/^\/([a-z]{2})(?=\/|$)/);
    
    if (localeMatch) {
        return localeMatch[1];
    }
    
    // 如果路径中没有语言代码，则是英语
    return 'en';
}

// 判断链接是否需要修改的函数
function shouldModifyLink(link) {
    // 已经是相对路径的链接不需要修改
    if (link.startsWith('/')) {
        return false;
    }
    
    // 包含inrobots.shop域名的链接需要修改
    if (link.includes('inrobots.shop')) {
        return true;
    }
    
    return false;
}

// 链接转换函数 - 将完整URL改为包含正确语言代码的相对路径
function convertLinkToRelative(originalLink) {
    try {
        const url = new URL(originalLink);
        const currentLocale = getCurrentLocale();
        
        // 只处理inrobots.shop域名的链接
        if (url.hostname.includes('inrobots.shop')) {
            let path = url.pathname;
            
            // 如果当前不是英语页面，需要添加语言前缀
            if (currentLocale !== 'en') {
                // 检查路径是否已经包含语言代码
                const hasLocale = path.match(/^\/([a-z]{2})(?=\/|$)/);
                
                if (!hasLocale) {
                    // 路径中没有语言代码，添加当前语言代码
                    path = '/' + currentLocale + path;
                } else if (hasLocale[1] !== currentLocale) {
                    // 路径中有语言代码，但和当前语言不同，替换为当前语言
                    path = path.replace(hasLocale[0], '/' + currentLocale);
                }
            } else {
                // 当前是英语页面，确保路径不包含语言代码
                const hasLocale = path.match(/^\/([a-z]{2})(?=\/|$)/);
                if (hasLocale) {
                    // 路径中有语言代码，移除它（英语是默认语言，不需要前缀）
                    path = path.replace(/^\/[a-z]{2}/, '');
                }
            }
            
            return path + url.search + url.hash;
        }
        
        return originalLink;
    } catch (e) {
        return originalLink;
    }
}

// 主修改函数
function modifyInternalLinks() {
    const allLinks = document.querySelectorAll('a[href]');
    
    allLinks.forEach(link => {
        const originalHref = link.getAttribute('href');
        
        if (shouldModifyLink(originalHref)) {
            const newHref = convertLinkToRelative(originalHref);
            
            if (newHref !== originalHref) {
                link.setAttribute('href', newHref);
            }
        }
    });
}

// 修改内容中的链接
function modifyContentLinks() {
    const contentSelectors = [
        '.product-description',
        '.article-content',
        '.page-content',
        '.rte',
        '[data-section-type="rich-text"]',
        '.shopify-policy__body',
        '.collection-description',
        '.page-template__content',
        '.main-content',
        '.content',
        '.description'
    ];
    
    const currentLocale = getCurrentLocale();
    
    contentSelectors.forEach(selector => {
        const elements = document.querySelectorAll(selector);
        elements.forEach(element => {
            const html = element.innerHTML;
            
            // 使用正则表达式替换完整URL为包含正确语言代码的相对路径
            const modifiedHtml = html.replace(
                /https?:\/\/[^\/]*inrobots\.shop(\/[^"']*)/g, 
                function(match, path) {
                    let newPath = path;
                    
                    if (currentLocale !== 'en') {
                        const hasLocale = newPath.match(/^\/([a-z]{2})(?=\/|$)/);
                        if (!hasLocale) {
                            newPath = '/' + currentLocale + newPath;
                        } else if (hasLocale[1] !== currentLocale) {
                            newPath = newPath.replace(hasLocale[0], '/' + currentLocale);
                        }
                    } else {
                        const hasLocale = newPath.match(/^\/([a-z]{2})(?=\/|$)/);
                        if (hasLocale) {
                            newPath = newPath.replace(/^\/[a-z]{2}/, '');
                        }
                    }
                    
                    return newPath;
                }
            );
            
            if (modifiedHtml !== html) {
                element.innerHTML = modifiedHtml;
            }
        });
    });
}

// 处理语言切换器链接
function modifyLanguageSwitcher() {
    // 查找语言切换器链接
    const langLinks = document.querySelectorAll('a[href*="inrobots.shop"]');
    const currentLocale = getCurrentLocale();
    
    langLinks.forEach(link => {
        const href = link.getAttribute('href');
        if (href && href.includes('inrobots.shop')) {
            const url = new URL(href);
            let path = url.pathname;
            
            if (currentLocale !== 'en') {
                const hasLocale = path.match(/^\/([a-z]{2})(?=\/|$)/);
                if (!hasLocale) {
                    path = '/' + currentLocale + path;
                } else if (hasLocale[1] !== currentLocale) {
                    path = path.replace(hasLocale[0], '/' + currentLocale);
                }
            } else {
                const hasLocale = path.match(/^\/([a-z]{2})(?=\/|$)/);
                if (hasLocale) {
                    path = path.replace(/^\/[a-z]{2}/, '');
                }
            }
            
            const newHref = path + url.search + url.hash;
            if (newHref !== href) {
                link.setAttribute('href', newHref);
            }
        }
    });
}

// 只在目标页面执行
function initLinkConverter() {
    if (isTargetPage()) {
        // 执行所有链接修改
        modifyInternalLinks();
        modifyContentLinks();
        modifyLanguageSwitcher();
        
        console.log('Link converter initialized for page:', window.location.pathname);
        
        // 监听动态内容加载
        if (typeof MutationObserver !== 'undefined') {
            const observer = new MutationObserver(function(mutations) {
                let shouldUpdate = false;
                
                mutations.forEach(function(mutation) {
                    if (mutation.type === 'childList') {
                        mutation.addedNodes.forEach(function(node) {
                            if (node.nodeType === 1) {
                                if (node.tagName === 'A' || 
                                    (node.querySelector && node.querySelector('a[href]'))) {
                                    shouldUpdate = true;
                                }
                                
                                // 检查是否为内容容器
                                const contentSelectors = [
                                    '.product-description',
                                    '.article-content',
                                    '.page-content',
                                    '.rte',
                                    '[data-section-type="rich-text"]',
                                    '.shopify-policy__body',
                                    '.collection-description',
                                    '.page-template__content',
                                    '.main-content',
                                    '.content',
                                    '.description'
                                ];
                                
                                for (const selector of contentSelectors) {
                                    if (node.classList && node.classList.contains(selector.replace('.', '')) || 
                                        (node.querySelector && node.querySelector(selector))) {
                                        shouldUpdate = true;
                                        break;
                                    }
                                }
                            }
                        });
                    }
                });
                
                if (shouldUpdate) {
                    modifyInternalLinks();
                    modifyContentLinks();
                    modifyLanguageSwitcher();
                }
            });
            
            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        }
    }
}

// 页面加载完成后执行
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLinkConverter);
} else {
    initLinkConverter();
}

// 兼容Turbo/SPA导航
if (typeof Turbo !== 'undefined') {
    document.addEventListener('turbo:load', initLinkConverter);
}

if (typeof Shopify !== 'undefined' && Shopify.designMode) {
    // 在主题编辑器中也运行
    document.addEventListener('shopify:section:load', initLinkConverter);
    document.addEventListener('shopify:block:select', initLinkConverter);
}